// * @Description: 隐患排查记录
<template>
  <el-card class="h-full relative">
    <el-tabs v-model="activeName">
      <el-tab-pane label="设备设施类" name="equipment">
        <CheckListEquipTable v-if="activeName === 'equipment'" />
      </el-tab-pane>
      <el-tab-pane label="作业活动类" name="work">
        <CheckListJobTable v-if="activeName === 'work'" />
      </el-tab-pane>
      <el-tab-pane label="基础管理类" name="base">
        <CheckListBaseTable v-if="activeName === 'base'" />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script>
import CheckListEquipTable from '../components/CheckList/CheckListEquipTable'
import CheckListJobTable from '../components/CheckList/CheckListJobTable'
import CheckListBaseTable from '../components/CheckList/CheckListBaseTable'

export default {
  name: 'check-list',
  components: {
    CheckListEquipTable,
    CheckListJobTable,
    CheckListBaseTable,
  },
  data() {
    return {
      activeName: 'equipment',
    }
  },
  methods: {},
  mounted() {},
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 54px) !important;
  position: inherit;
  .el-tab-pane {
    height: 100%;
  }
}
</style>
